module.exports = __webpack_public_path__ + "img/sword-earth-04.24309db8.png";